import { render, staticRenderFns } from "./IconInbox.vue?vue&type=template&id=a7734d7a"
import script from "./IconInbox.vue?vue&type=script&lang=js"
export * from "./IconInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports